(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmt-proof"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bmt-review-carousel')) {
  customElements.define('bmt-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('.bmt-proof-grid');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.direction))));
      this.addEventListener('mouseenter', () => { this.hovered = true; });
      this.addEventListener('mouseleave', () => { this.hovered = false; });
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && !this.contains(document.activeElement) && !document.hidden) this.move(1);
      }, 5000);
    }
    move(direction) {
      const step = this.track.querySelector('figure').getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
      const max = this.track.scrollWidth - this.track.clientWidth;
      let left = this.track.scrollLeft + step * direction;
      if (left > max + 2) left = 0;
      if (left < -2) left = max;
      this.track.scrollTo({left, behavior: this.reduced.matches ? 'auto' : 'smooth'});
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      delete this.dataset.ready;
    }
  });
}

if (!customElements.get('bmt-reviews-popup')) {
  customElements.define('bmt-reviews-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.dialog = this.querySelector('dialog');
      this.content = this.querySelector('[data-review-content]');
      this.openers = this.querySelectorAll('[data-bmt-review-open]');
      this.openers.forEach(link => link.addEventListener('click', event => { event.preventDefault(); this.open(link); }));
      this.querySelector('[data-review-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.opener?.focus();
      });
      const initialize = () => {
        this.source = document.querySelector('[id$="__loox-product-reviews-app-section"]');
        if (this.source) {
          this.source.hidden = true;
          document.querySelectorAll('a[href="#looxReviewsFrame"]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); this.open(link); }));
        }
        if (location.hash === '#looxReviewsFrame') this.open(this.openers[0]);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
      else initialize();
    }
    open(opener) {
      this.opener = opener;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      if (this.source && !this.content.contains(this.source)) {
        this.content.append(this.source);
        this.source.hidden = false;
      } else if (!this.source && !this.content.querySelector('iframe')) {
        const frame = document.createElement('iframe');
        frame.title = this.dialog.querySelector('h2').textContent;
        frame.src = 'https://loox.io/widget/VJ-6Dqa9hi/reviews/' + this.dataset.productId + '?limit=5&default_tab=automatic';
        this.content.append(frame);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bmt-sticky"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bmt-sticky-purchase')) {
  customElements.define('bmt-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.init = () => {
        this.info = document.querySelector('.bmt-pdp .product__info-container');
        this.form = this.info?.querySelector('form[data-type="add-to-cart-form"]');
        this.submit = this.form?.querySelector('button[name="add"]');
        if (!this.form || !this.submit || !('IntersectionObserver' in window)) return;
        this.variants = JSON.parse(this.querySelector('[data-bmt-sticky-variants]').textContent);
        this.button = this.querySelector('[data-bmt-sticky-submit]');
        this.label = this.querySelector('[data-bmt-sticky-variant]');
        this.price = this.querySelector('[data-bmt-sticky-price]');
        this.sync = () => {
          const nextForm = this.info.querySelector('form[data-type="add-to-cart-form"]');
          if (nextForm) this.form = nextForm;
          this.submit = this.form.querySelector('button[name="add"]');
          if (!this.submit) { this.hidden = true; return; }
          const id = this.form.querySelector('[name="id"]')?.value;
          const variant = this.variants.find(item => String(item.id) === String(id));
          this.label.textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
          this.label.hidden = !this.label.textContent;
          this.price.textContent = variant ? variant.price : '';
          const text = this.submit.querySelector('span')?.textContent.trim() || this.submit.textContent.trim();
          this.button.textContent = text;
          this.button.disabled = !variant?.available || this.submit.disabled || this.submit.getAttribute('aria-disabled') === 'true';
        };
        this.updateVisibility = () => {
          this.hidden = this.submit.getBoundingClientRect().bottom > 0;
          document.body.classList.toggle('bmt-has-sticky-purchase', !this.hidden);
        };
        this.onClick = () => {
          this.sync();
          if (this.button.disabled) return;
          this.submit.click();
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.info.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        };
        this.button.addEventListener('click', this.onClick);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.info, { subtree: true, childList: true, attributes: true, attributeFilter: ['value','disabled','aria-disabled','class'] });
        this.info.addEventListener('change', this.sync);
        this.intersection = new IntersectionObserver(this.updateVisibility, { threshold: [0, 1] });
        this.intersection.observe(this.submit);
        this.sync();
        this.updateVisibility();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.init, {once:true});
      else this.init();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.init);
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.info?.removeEventListener('change', this.sync);
      this.button?.removeEventListener('click', this.onClick);
      document.body.classList.remove('bmt-has-sticky-purchase');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product_bak_mzp_20230227_065417"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product_bak_mzp_20230302_061320"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
